<section class="modern-host" [attr.aria-busy]="active() && !revealed()">
  @if (active() && showLoading()) {
    <div class="modern-host__loading" role="status" aria-label="Loading application">
      <span aria-hidden="true"></span>
    </div>
  }
  <iframe
    #modernFrame
    class="modern-host__frame"
    [class.modern-host__frame--visible]="revealed()"
    [attr.title]="frameTitle()"
    loading="eager"
    (load)="onFrameLoad()"
    (error)="onFrameError()"
  >
  </iframe>
</section>
